import React from "react"

import NavigationSection from "../../../core/model2/navigation/navigation-section"
import {NavigationButtonPosition} from "../../../core/model2/navigation/@const"
import {ReorderItemProps} from "../../../core/gd-ui/sortable-list-4/@types"
import Navigation_ButtonHint from "../hint/hint";
import PopoverMenu from "../../../core/gd-components/popover-menu/popover-menu/popover-menu";

type Props = {
    className?          : string,
    section             : NavigationSection,
    onClickCallback?    : callback
    inMorePopover       : boolean
} & ReorderItemProps

export default class Navigation_ButtonAttendance extends React.Component<Props,any> {

    public refHint: React.RefObject<Navigation_ButtonHint> = React.createRef<Navigation_ButtonHint>()

    constructor(props: Props) {
        super(props);

        this.state = {
            status: false
        }
    }

    showContextMenu = (e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()

        const options = this.props.section.positionOptions

        if (_.size(options) < 1) {
            return null
        }

        gd.layout.contextMenu.show(e,
            <PopoverMenu options        = {options}
                         hidePopover    = {() => gd.layout.contextMenu.hide()}/>,
            {
                component: this
            }
        )
    }

    componentDidMount() {
        gd.bus.subscribe("attendance:update", this, this.getStatus)
        this.getStatus()
    }

    getStatus = async ()=>{
        try{
            const status = await gd.session.attendanceStatus()

            this.setState({
                status: status
            })
        }
        catch (e: any){
            console.error(e)
        }
    }

    onClick = async () => {
        if (this.props.onClickCallback) this.props.onClickCallback()

        this.refHint?.current?.hideHint()

        await gd.layout.navigation.openSectionV2(this.props.section)

        gd.goTo(this.props.section.defaultAppUrl || "clock-in-out")
    }

    render() {
        const isSelected = gd.layout.navigation.state.currentSection === this.props.section

        const homeClasses = Classes('ui5-navigation-btn', this.props.className, 'i5-my-attendance', {
            // 'i5-my-attendance': !isSelected,        // Add when a solid icon is created!
            // 'i5-my-attendance-solid': isSelected,   // This icon has not been drawn yet!
            selected        : isSelected && !this.props.inMorePopover,
            'is-dragged'    : this.props.dndIsDragged,
            'is-hover'      : !this.props.dndIsDragInProgress && this.props.isMouseEntered,
            'is-preview'    : this.props.dndPreview
        })

        return (
            <div className={homeClasses} onClick={this.onClick} onContextMenu={this.showContextMenu}>
                {this.props.section.position !== NavigationButtonPosition.MORE &&
                    <Navigation_ButtonHint ref = {this.refHint} section={this.props.section}/>}
                <div className={Classes("btn-indicator", this.state.status ? "indicator-on" : "indicator-off")}></div>
            </div>
        )
    }
}
